import React from 'react';

import styles from './styles.module.css';

type ShimmerEffectProps = {
  children: React.ReactNode;
  className?: string;
  delay?: string;
};

export const ShimmerEffect = ({
  children,
  className = '',
  delay = '0s',
}: ShimmerEffectProps) => {
  return (
    <div
      className={`${styles.shimmerWrapper} ${className}`}
      style={{ '--shimmer-delay': delay } as React.CSSProperties}
    >
      {children}
    </div>
  );
};
